import Page from './Page';
import Component from 'vue-class-component';

import template from './MobileOrdered.vue.html';
import HeaderComponent from './Header.vue';
import TabBar from './TabBar.vue';
import { format } from 'date-fns';
import { ConsumptionTax } from '../common/ConsumptionTax';

type Ordered = {
    uid: string | null;
    quantity: number;
    unit_price: number;
    order_date: string;
    title: Record<'ja' | 'en' | 'ko' | 'cn', string>;
    unit: Record<'ja' | 'en' | 'ko' | 'cn', string>;
    sales_unit: 'quantity_unit' | 'time_unit';
    start_time: string;
    end_time: string;
    tax_percent: number;
    include_tax: boolean;
    amountIncludingTax: () => number;
};

type GratuityOrdered = {
    id: number;
    gratuity_staff_id: number;
    remarks: string;
    created: string;
    amount: number;
};

@Component({ template, components: { HeaderComponent, TabBar } })
export default class MobileOrdered extends Page {
    orders: Ordered[] = [];
    gratuity_orders: GratuityOrdered[] = [];

    async created() {
        const [result, _] = await Promise.all([
            this.app.post('mobile-ordered'),
            this.app.fetchInfo(),
        ]);
        if (!result.succeed) {
            alert(result.error ? this._(result.error.message_code) : 'Error');
            return;
        }
        this.orders = result.orders.map(
            (order: Omit<Ordered, 'amountIncludingTax'>): Ordered => ({
                ...order,
                amountIncludingTax: function () {
                    return new ConsumptionTax({
                        amount: this.unit_price,
                        tax_percent: this.tax_percent,
                        include_tax: this.include_tax,
                    }).amountIncludingTax;
                },
            })
        );

        // チップのオーダー一覧を取得する記述ここから
        if (this.app.enabled_gratuity && this.app.gratuity.max_amount > 0) {
            const [result, _] = await Promise.all([
                this.app.post('gratuity-ordered'),
                this.app.fetchInfo(),
            ]);
            if (!result.succeed) {
                alert(
                    result.error ? this._(result.error.message_code) : 'Error'
                );
                return;
            }
            this.gratuity_orders = result.orders;
        }
        // チップのオーダー一覧を取得する記述ここまで

        const uids = this.orders.map((o) => o?.uid ?? '');
        this.app.cart?.remove(...uids);

        await this.$nextTick();
        this.$forceUpdate();
    }

    totalOrderedPrice() {
        return (
            this.orders
                .map((o) => o.amountIncludingTax() * o.quantity)
                .reduce((a, c) => a + c, 0) +
            this.gratuity_orders.map((o) => o.amount).reduce((a, c) => a + c, 0)
        );
    }

    schedule(order: Ordered) {
        if (order.sales_unit !== 'time_unit') return null;
        const start = new Date(order.start_time);
        const end = new Date(order.end_time);
        return `${format(start, 'MM/dd')} ${format(start, 'HH:mm')} ～ ${format(
            end,
            'HH:mm'
        )}`;
    }
}
